var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 30,
    cy: 30,
    r: 29.25,
    fill: "white",
    stroke: "#151319",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M36.4023 29.1584C37.0157 29.5519 37.0157 30.4483 36.4023 30.8418L27.6829 36.4353C27.0173 36.8623 26.1429 36.3844 26.1429 35.5936V24.4066C26.1429 23.6159 27.0173 23.138 27.6829 23.5649L36.4023 29.1584Z",
    fill: "#151319"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.055f02741139abfb001722feb9745487.svg";
export { ForwardRef as ReactComponent };